import type {UpdateCompanyDocumentsChanges} from './update'

export const mergeDocumentChanges = (
  changes: Record<string, UpdateCompanyDocumentsChanges>
): UpdateCompanyDocumentsChanges =>
  Object.values(changes).reduce(
    (res, change) => ({
      ...res,
      ...(change.added?.length ? {added: [...res.added, ...change.added]} : null),
      ...(change.removed?.length ? {removed: [...res.removed, ...change.removed]} : null),
      ...(change.modifications?.length
        ? {modifications: [...res.modifications, ...change.modifications]}
        : null),
    }),
    {
      added: [] as UpdateCompanyDocumentsChanges['added'],
      removed: [] as UpdateCompanyDocumentsChanges['removed'],
      modifications: [] as UpdateCompanyDocumentsChanges['modifications'],
    } as UpdateCompanyDocumentsChanges
  )
